// src/admin/pages/Restaurants/MenusSection.js
import React, { useState, useEffect } from "react";
import MenuFilters from "./MenuFilters";
import CreateMenuForm from "./CreateMenuForm";
import MenuList from "./MenuList";
import MenuDetails from "./MenuDetails";
import "./MenusSection.css";

export default function MenusSection({ restaurant }) {
  const [menus, setMenus] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [error, setError] = useState("");

  // Filtri
  const [showActive, setShowActive] = useState(true);
  const [showInactive, setShowInactive] = useState(false);

  // Categorie globali (per i dropdown ecc.)
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchMenus();
    fetchCategories();
    // eslint-disable-next-line
  }, [restaurant]);

  const fetchMenus = async () => {
    setError("");
    try {
      const token = localStorage.getItem("access_token");
      const url = `${process.env.REACT_APP_API_URL}/menus?restaurant_id=${restaurant.id}`;
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        throw new Error("Errore durante il caricamento dei menù");
      }
      const data = await res.json();
      setMenus(data);

      // Se il menù selezionato non esiste più, lo deselezioniamo
      setSelectedMenu((prev) =>
        prev && data.some((m) => m.id === prev.id) ? prev : null
      );
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/categories`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        console.error("Impossibile caricare le categorie");
        return;
      }
      const data = await res.json(); // array di stringhe
      setCategories(data);
    } catch (error) {
      console.error("Errore fetch categories:", error);
    }
  };

  const handleMenuCreated = (newMenu) => {
    newMenu.restaurant_id = restaurant.id;
    setMenus((prev) => [...prev, newMenu]);
  };

  const handleSelectMenu = (menu) => {
    setSelectedMenu(menu);
  };

  const handleMenuUpdated = (updatedMenu) => {
    setMenus((prev) =>
      prev.map((m) => (m.id === updatedMenu.id ? updatedMenu : m))
    );
    setSelectedMenu(updatedMenu);
  };

  // Filtro menù in base a showActive/showInactive
  const filteredMenus = menus.filter((m) => {
    if (m.active) return showActive;
    return showInactive;
  });

  return (
    <div className="menus-section-container">
      <h2 className="menus-title">Gestione Menù</h2>
      {error && <p className="error-text">{error}</p>}

      {/* Blocco superiore: filtri + form creazione */}
      <div className="menu-top-row">
        <div className="menu-filters-block">
          <MenuFilters
            showActive={showActive}
            setShowActive={setShowActive}
            showInactive={showInactive}
            setShowInactive={setShowInactive}
          />
        </div>
        <div className="create-menu-block">
          <CreateMenuForm
            restaurant={restaurant}
            onMenuCreated={handleMenuCreated}
          />
        </div>
      </div>

      {/* Contenuto principale: lista a sinistra, dettaglio a destra (o in colonna su mobile) */}
      <div className="menus-content">
        <div className="menu-list-area">
          <MenuList
            menus={filteredMenus}
            selectedMenu={selectedMenu}
            onSelectMenu={handleSelectMenu}
            onMenuUpdated={handleMenuUpdated}
          />
        </div>
        <div className="menu-details-area">
          {selectedMenu ? (
            <MenuDetails
              menu={selectedMenu}
              onMenuUpdated={handleMenuUpdated}
              categories={categories}
            />
          ) : (
            <p className="no-menu-selected-text">
              Seleziona un menù per vedere i dettagli
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
